import { createSelector } from "reselect";
import { currentLocation } from "routes/currentLocation";
import { getSidebarLocation } from "lib/locationHelpers";
import InputMode from "lib/InputMode";

export const getSearchPath = _state => currentLocation().search;

// Read the search string from the mirrored redux location slice so reselect's
// memoisation is keyed on Redux state. Query-only navigation flips
// state.ui.location on ROUTE_CHANGED, which is what lets connected sidebar tabs
// recompute sidebarLocation instead of returning a cached value.
const locationSearchSelector = state => state.ui.location.search;

/**
 * Memoised sidebar location. getSidebarLocation returns a fresh object on every
 * call, so calling it directly in mapStateToProps would defeat connect's
 * bailout and rerender on every dispatch. Keying on the search string (and im
 * mode, which getSidebarLocation also reads) keeps the reference stable until
 * the URL actually changes.
 */
export const sidebarLocationSelector = createSelector(
  locationSearchSelector,
  () => InputMode.isImModeOn(),
  search => getSidebarLocation(search)
);
